module.exports = __webpack_public_path__ + "static/img/default-logo.d78e0150.png";